import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import TopNav from "../components/TopNav";
import "../App.css";

function EditJob() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    desc: "",
    place: "",
    salary: "",
    type: "",
    occ: "",
    image: "",
    tag_names: [],
  });
  const [tagInput, setTagInput] = useState("");

  useEffect(() => {
    const fetchJob = async () => {
      const docRef = doc(db, "items", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setForm({
          ...data,
          desc: data.desc?.replace(/<br\s*\/?>/g, "\n") || "",
          tag_names: data.tag_names || [],
        });
      }
    };
    fetchJob();
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateDoc(doc(db, "items", id), {
        ...form,
        desc: form.desc.replace(/\n/g, "<br>"),
      });
      alert("Job updated successfully");
      navigate("/admin");
    } catch (err) {
      alert("Failed to update job: " + err.message);
    }
  };

  const handleAddTag = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmed = tagInput.trim();
      if (
        trimmed &&
        form.tag_names.length < 10 &&
        !form.tag_names.includes(trimmed)
      ) {
        setForm((prev) => ({
          ...prev,
          tag_names: [...prev.tag_names, trimmed],
        }));
        setTagInput("");
      }
    }
  };

  const handleRemoveTag = (index) => {
    const updated = form.tag_names.filter((_, i) => i !== index);
    setForm({ ...form, tag_names: updated });
  };

  return (
    <div className="auth-container">
      <TopNav />
      <div className="upload_section">
        <h1 className="auth-heading upload">Edit Job</h1>
        <form className="auth-form" onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Job Name" value={form.name} onChange={handleChange} required />
          <input type="url" name="image" placeholder="Image URL" value={form.image} onChange={handleChange} />
          <textarea name="desc" placeholder="Job Description" value={form.desc} onChange={handleChange} required className="textarea-input" />
          <input type="text" name="place" placeholder="Location" value={form.place} onChange={handleChange} required />
          <input type="text" name="salary" placeholder="Salary" value={form.salary} onChange={handleChange} />
          <select name="type" value={form.type} onChange={handleChange} required>
            <option value="">Select Job Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
          </select>
          <input type="text" name="occ" placeholder="Category" value={form.occ} onChange={handleChange} required />

          <div className="tag-section">
            <input
              type="text"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              placeholder="Add tag and press Enter"
              onKeyDown={handleAddTag}
            />
            <div className="tag-list">
              {form.tag_names.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                  <button type="button" onClick={() => handleRemoveTag(index)}>×</button>
                </span>
              ))}
            </div>
            {form.tag_names.length >= 10 && (
              <p className="tag-warning">You can only add up to 10 tags.</p>
            )}
          </div>

          <button className="auth-btn login_btn" type="submit">
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditJob;
